module.exports = __webpack_public_path__ + "img/jaihind.b2ebf4ad.jpg";